import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppointmentRoutingModule } from './appointment-routing.module';
import { AppointmentComponent } from './appointment.component';
import { ActionCenterComponent } from './action-center/action-center.component';
import {GridModule} from "@progress/kendo-angular-grid";
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [AppointmentComponent, ActionCenterComponent],
  exports: [
    AppointmentComponent,
    TranslateModule
  ],
  imports: [
    CommonModule,
    AppointmentRoutingModule,
    GridModule,
    TranslateModule
  ]
})
export class AppointmentModule { }
